import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types';

import Typography from "@material-ui/core/Typography/index";
import PictureAsPdf from '@material-ui/icons/PictureAsPdf';
import EventNote from '@material-ui/icons/EventNote';
import Sync from '@material-ui/icons/Sync';
import ListaTabla from './Includes/ListaTabla';
import ModalEjecutivoAsignado from './Includes/ModalEjecutivoAsignado';

import {EjecutivoAsignadoService} from '../../../../services/_Cat/EjecutivoAsignadoService/EjecutivoAsignadoService';
import {PopupService} from '../../../../settings/PoPup/PoPup';
import {FieldsJs} from "../../../../settings/General/General";
import {ReactLocalStorageService} from '../../../../settings/ReactLocalStorageService/ReactLocalStorageService';
import Zoom from '@material-ui/core/Zoom/index';
import Add from '@material-ui/icons/Add';
import Fab from "@material-ui/core/Fab/index";
import {CatService} from "../../../../services/_Cat/CatService/CatService";
import VistaVacia from "../../../Include/VistaVacia/VistaVacia";

import IntegrationNotistack, {ShowSnackBarsNotistack} from "../../../../settings/IntegrationNotistack/IntegrationNotistack";
import {CONFIG} from "../../../../settings/Config/Config";


class EjecutivoAsignado extends Component {
	
	state = {
		modal: {
			open: false,
			title: '',
			tipo: ''
		},
		form: {
			id_ejecutivo_asignado_tesoreria: '',
			id_usuario: '',
			descripcion: '',
			activo: false
		},
		cat_usuario_ejecutivo: [],
		listar_ejecutivo_asignado_tesoreria: []
	};
	
	Usr = {};
	
	constructor() {
		super();
		
		this.Usr = ReactLocalStorageService.get('Usr') || {};
		
		this.handleChange = this.handleChange.bind(this);
		this.showSnackBars = this.showSnackBars.bind(this);
		
		this.save = this.save.bind(this);
		this.delete = this.delete.bind(this);
		this.add = this.add.bind(this);
		this.edit = this.edit.bind(this);
		this.view = this.view.bind(this);
		
		this.Listar = this.Listar.bind(this);
		
		this.Listar();
	}
	
	handleChange(e) {
		const {value, name, checked, type} = e.target;
		let form = this.state.form;
		form[name] = type === 'checkbox' ? checked : value;
		this.setState({
			form: form
		});
	}
	
	showSnackBars(type, message) {
		ShowSnackBarsNotistack(this.props, type, message, null);
	};
	
	Listar = () => {
		EjecutivoAsignadoService.Listar().then((response) => {
			
			this.setState({listar_ejecutivo_asignado_tesoreria: response.data});
			
		}).catch((error) => {
			
			this.setState({listar_ejecutivo_asignado_tesoreria: []});
			
			this.showSnackBars('error', error.mensaje);
			
		});
	};
	
	cat_usuario_ejecutivo = () => {
		CatService.ListUsuarioEjecutivo().then((response) => {
			this.setState({cat_usuario_ejecutivo: response.data});
		}).catch((error) => {
			this.setState({cat_usuario_ejecutivo: []});
			this.showSnackBars('error', error.mensaje);
		});
	};
	
	delete = (item) => {
		
		let msg = `¿Deseas eliminar el sexo ${item.sexo}?`;
		
		PopupService.Confirm(['Cancelar', 'Eliminar'], 'warning', CONFIG.titulo_alert_confirm, msg).then((r) => {
			
			if (r.button === 'Eliminar') {
				EjecutivoAsignadoService.Eliminar(item.id_ejecutivo_asignado_tesoreria).then((response) => {
					
					this.showSnackBars('success', response.mensaje);
					
					this.Listar();
					
				}).catch((error) => {
					
					this.showSnackBars('error', error.mensaje);
					
				});
			}
			
		});
	};
	
	save = () => {
		if (this.state.form.id_ejecutivo_asignado_tesoreria > 0) {
			EjecutivoAsignadoService.Modificar(this.state.form).then((response) => {
				this.closeModal();
				this.Listar();
				this.showSnackBars('success', response.mensaje);
			}).catch((error) => {
				this.showSnackBars('error', error.mensaje);
			});
		} else {
			EjecutivoAsignadoService.Agregar(this.state.form).then((response) => {
				this.closeModal();
				this.Listar();
				this.showSnackBars('success', response.mensaje);
			}).catch((error) => {
				this.showSnackBars('error', error.mensaje);
			});
		}
	};
	
	add = () => {
		
		this.cat_usuario_ejecutivo();
		
		let form = {
			id_ejecutivo_asignado_tesoreria: '',
			id_usuario: '',
			descripcion: '',
			activo: true
		};
		
		this.openModal('add', form);
		
	};
	
	edit = (item) => {
		
		this.cat_usuario_ejecutivo();
		
		let form = {
			id_ejecutivo_asignado_tesoreria: item.id_ejecutivo_asignado_tesoreria,
			id_usuario: item.id_usuario,
			descripcion: item.descripcion,
			activo: (item.activo === 1)
		};
		
		this.openModal('edit', form);
		
	};
	
	view = (item) => {
		
		this.cat_usuario_ejecutivo();
		
		let form = {
			id_ejecutivo_asignado_tesoreria: item.id_ejecutivo_asignado_tesoreria,
			id_usuario: item.id_usuario,
			descripcion: item.descripcion,
			activo: (item.activo === 1)
		};
		
		this.openModal('view', form);
		
	};
	
	openModal = (tipo, form) => {
		let title = "";
		switch (tipo) {
			case 'add':
				title = "Agregar";
				break;
			case 'edit':
				title = "Editar";
				break;
			case 'view':
				title = "Detalle";
				break;
			default:
		}
		this.setState({
			modal: {
				open: true,
				title: title,
				tipo: tipo
			},
			form: form
		});
	};
	
	closeModal = () => {
		this.setState({
			modal: {
				open: false,
				title: '',
				tipo: ''
			},
			form: {
				id_ejecutivo_asignado_tesoreria: '',
				id_usuario: '',
				descripcion: '',
				activo: false
			}
		})
	};
	
	render() {
		
		return (
			<div className='Catalogos ContaineViewComponet'>
				
				<Fragment>
					
					<ModalEjecutivoAsignado modal={this.state.modal} form={this.state.form} save={this.save}
					                        closeModal={this.closeModal} handleChange={this.handleChange}
					                        cat_usuario_ejecutivo={this.state.cat_usuario_ejecutivo}
					/>
				
				</Fragment>
				
				<div className={'row-flex margin-30-T margin-30-B'}>
					<div className={'w-100-300-px'}>
						<Typography variant={'h5'} className={'text-left'}>
							Ejecutivo asignado a tesorería
						</Typography>
					</div>
					<div className={'w-300-px text-right'}>
						{FieldsJs.inArray([1, 2], this.Usr.id_cat_tipo_usuario) ? (
							<Fab variant="extended" size="small" color="primary" aria-label="PDF"
							     className={'margin-10-L bg-danger'}>
								<PictureAsPdf className={'margin-5-R px-14'}/>
								PDF
							</Fab>
						) : ''}
						{FieldsJs.inArray([1, 2], this.Usr.id_cat_tipo_usuario) ? (
							<Fab variant="extended" size="small" color="primary" aria-label="Excel"
							     className={'margin-10-L bg-green'}>
								<EventNote className={'margin-5-R px-14'}/>
								Excel
							</Fab>
						) : ''}
						<Fab variant="extended" size="small" color="primary" aria-label="Add"
						     className={'margin-10-L'} onClick={this.Listar}>
							<Sync className={'margin-5-R px-14'}/>
							Actualizar
						</Fab>
					</div>
				</div>
				
				<div className={'form margin-30-B'}>
					
					<Typography variant={'h6'} className={'margin-30-T margin-30-B'}>
					
					</Typography>
					
					{this.state.listar_ejecutivo_asignado_tesoreria.length > 0 ? (
						<ListaTabla lista={this.state.listar_ejecutivo_asignado_tesoreria}
						            edit={this.edit}
						            view={this.view}
						            delete={this.delete}
						/>
					) : (
						<VistaVacia
							numero={0}
							mensaje={'No se encontraron datos.'}
						/>
					)}
				
				</div>
				
				<Zoom className={'btn-fixed-bottom-right cursor-pointer'} key={'inherit'} timeout={1500} in={true}
				      style={{transitionDelay: `${100}ms`}} unmountOnExit>
					<Fab color={'primary'} onClick={() => this.add()}>
						<Add/>
					</Fab>
				</Zoom>
			
			</div>
		);
	}
}

EjecutivoAsignado.propTypes = {
};

export default IntegrationNotistack(EjecutivoAsignado);
